import { Collection, RefNumber } from "@tblabs/truffle";
import { Discount } from "./Discount";
import { SelfTrainingDiscount } from "./SelfTrainingDiscount";
import { CryptoDiscount } from "./CryptoDiscount";
import { ReturningClientDiscount } from "./ReturningClientDiscount";


export class BasketConfig
{
    public GeneralPriceFactor = new RefNumber(1);
    public DeliveryCostForPriceAbove300 = new RefNumber(25);
    public DeliveryCostForPriceBelow300 = new RefNumber(1);
    public Discounts = new Collection<Discount>([
        new CryptoDiscount(),
        new ReturningClientDiscount(),
        new SelfTrainingDiscount(),
    ]);
    // public Extras = new Collection<ExtraCost>([
    //     // new ExtraCost({ Name: "odbiór poza godzinami pracy", Code: "after-hours", Value: 3, IsVisible: true }),
    //     // new ExtraCost({ Name: "ubezpieczenie od zgubienia", Code: "insurance", Value: 10, IsVisible: true }),
    //     // new ExtraCost({ Name: "pakiet ratunkowy", Code: "rescue-package", Value: 10, IsVisible: true, Description: "W pakiecie ratunkowym znajduje się komplet zapasowych elementów zestawu, za który zapłacisz tylko w razie awarii" })
    // ]);
}
